







































































import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';

export enum HistogramType {
  Quality = 'quality',
  Difficulty = 'difficulty',
}

@Component
export default class ProblemHistogram extends Vue {
  @Prop() type!: string;
  @Prop() histogram!: number[];
  @Prop() score!: number;

  T = T;

  get tags(): string[] {
    return this.type === HistogramType.Quality
      ? [
          T.qualityFormQualityVeryGood,
          T.qualityFormQualityGood,
          T.qualityFormQualityFair,
          T.qualityFormQualityBad,
          T.qualityFormQualityVeryBad,
        ]
      : [
          T.qualityFormDifficultyVeryEasy,
          T.qualityFormDifficultyEasy,
          T.qualityFormDifficultyMedium,
          T.qualityFormDifficultyHard,
          T.qualityFormDifficultyVeryHard,
        ];
  }

  get title(): string {
    return this.type === HistogramType.Quality
      ? T.wordsQuality
      : T.wordsDifficulty;
  }

  get customHistogram(): number[] {
    return this.type === HistogramType.Quality
      ? this.histogram.reverse()
      : this.histogram;
  }

  get totalVotes(): number {
    return this.histogram.reduce((a: number, b: number) => a + b);
  }

  get barsWidth(): number[] {
    const maxValue = Math.max(...this.customHistogram);
    if (maxValue === 0) return [0, 0, 0, 0, 0];
    return this.customHistogram.map((value) => (value / maxValue) * 100);
  }
}
